module.exports = __webpack_public_path__ + "img/no_thumb.c3684c57.svg";